import React, { createContext, useContext, useState, useCallback, useMemo, startTransition } from 'react';

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);

    const toggleSidebar = useCallback(() => {
        startTransition(() => {
            setIsCollapsed(prev => !prev);
        });
    }, []);

    const contextValue = useMemo(() => ({
        isCollapsed,
        toggleSidebar
    }), [isCollapsed, toggleSidebar]);

    return (
        <SidebarContext.Provider value={contextValue}>
            {children}
        </SidebarContext.Provider>
    );
};

export const useSidebar = () => {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error('useSidebar must be used within a SidebarProvider');
    }
    return context;
};

